var map = {
	"./assustado.png": 6949,
	"./falando.png": 2647,
	"./falando2.png": 3589,
	"./falando_feliz.png": 3790,
	"./falando_feliz2.png": 9358,
	"./feliz.png": 5908,
	"./normal.png": 9343,
	"./sorriso2.png": 8575,
	"./sorrisp.png": 5198,
	"./triste.png": 4309
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4623;